import { Link } from 'react-router-dom'

const productLinks = [
  { label: 'Features', href: '/#features' },
  { label: 'Pricing', href: '/#pricing' },
  { label: 'FAQ', href: '/#faq' },
]

const resourceLinks = [
  { label: 'Blog', href: '/blog' },
  { label: 'Affiliate Program', href: '/affiliates' },
  { label: 'Contact', href: '/contact' },
]

const toolLinks = [
  { label: 'DRIP Calculator', href: '/drip-calculator' },
  { label: 'Covered Call Tracker', href: '/covered-call-tracker' },
  { label: 'Glossary', href: '/glossary' },
]

const compareLinks = [
  { label: 'vs Snowball Analytics', href: '/vs-snowball-analytics' },
  { label: 'vs Track Your Dividends', href: '/vs-track-your-dividends' },
  { label: 'vs Simply Safe Dividends', href: '/vs-simply-safe-dividends' },
]

const legalLinks = [
  { label: 'Privacy Policy', href: '/privacy-policy' },
  { label: 'Terms of Service', href: '/terms' },
]

export default function LPFooter() {
  return (
    <footer className="bg-charcoal">
      <div className="content-max pt-16 pb-12 lg:pt-20 lg:pb-12">
        {/* Top Row */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-8 mb-12">
          {/* Brand */}
          <div className="col-span-2 sm:col-span-3 lg:col-span-2 max-w-[280px]">
            <div className="flex items-center gap-2.5 mb-4">
              <img src="/logo.png" alt="" className="w-7 h-7" />
              <span className="font-sans font-medium text-base text-white">
                Safe Dividend Tracker
              </span>
            </div>
            <p className="text-sm text-warm-grey leading-relaxed mb-5">
              The complete platform for dividend and options income tracking.
            </p>
            {/* App Store Badges */}
            <div className="flex flex-col gap-2.5">
              <a
                href="https://apps.apple.com/app/id6761783631"
                target="_blank"
                rel="noopener noreferrer"
                className="w-fit opacity-90 hover:opacity-100 transition-opacity duration-300"
              >
                <img src="/badge-app-store.svg" alt="Download on the App Store"
                  style={{ height: 40, width: 'auto', display: 'block' }} />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.safedividendtracker.app"
                target="_blank"
                rel="noopener noreferrer"
                className="w-fit opacity-90 hover:opacity-100 transition-opacity duration-300"
                style={{ overflow: 'hidden' }}
              >
                <img src="/badge-google-play.png" alt="Get it on Google Play"
                  style={{ height: 58, width: 'auto', display: 'block', marginTop: -9, marginBottom: -9 }} />
              </a>
            </div>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-sm font-medium text-white mb-4">Product</h4>
            <ul className="space-y-2.5">
              {productLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-warm-grey hover:text-gold transition-colors duration-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <a href="/login" className="text-sm text-warm-grey hover:text-gold transition-colors duration-300">
                  Sign In
                </a>
              </li>
              <li>
                <a href="/register" className="text-sm text-warm-grey hover:text-gold transition-colors duration-300">
                  Get Started
                </a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-sm font-medium text-white mb-4">Resources</h4>
            <ul className="space-y-2.5">
              {resourceLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-warm-grey hover:text-gold transition-colors duration-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Tools */}
          <div>
            <h4 className="text-sm font-medium text-white mb-4">Tools</h4>
            <ul className="space-y-2.5">
              {toolLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-warm-grey hover:text-gold transition-colors duration-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Compare */}
          <div>
            <h4 className="text-sm font-medium text-white mb-4">Compare</h4>
            <ul className="space-y-2.5">
              {compareLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-warm-grey hover:text-gold transition-colors duration-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-sm font-medium text-white mb-4">Legal</h4>
            <ul className="space-y-2.5">
              {legalLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-warm-grey hover:text-gold transition-colors duration-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Row */}
        <div className="border-t border-border-dark pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-warm-grey">
            &copy; 2026 Safe Dividend Tracker. All rights reserved.
          </p>
          <p className="text-xs text-warm-grey hidden sm:block">
            Not financial advice. All projections are hypothetical.
          </p>
        </div>
      </div>
    </footer>
  )
}
